<template>
    <div class="all-card-container">
        <div class="add-ons">
            <label style="font-size: large;">Add-ons</label> 
            <div class="single-counter">
                <div><i class="fa-solid fa-coins" style="margin-right: 0.3rem;"></i>Add Tokens</div>
                <div style="margin-left: 1rem;margin-top: 0.5rem;">
                    {{ CurrencyCode }} {{ tokenAddon ? tokenAddon.addonPrice : 0 }} /per unit
                    <button class="count-btn" @click="decrementToken" :disabled="tokenCount <= 0">-</button> 
                    {{ tokenCount }} 
                    <button class="minus-count-btn" @click="incrementToken" :disabled="tokenCount >= maxTokenCount">+</button>
                </div>
                <div style="margin-left: 1rem; margin-top: 0.6rem;opacity:50%; font-size: 15px;">
                    This token will only be accessible if plan is active
                </div>
            </div>
            <div class="single-counter">
                <div><i class="fa fa-users" aria-hidden="true" style="margin-right: 0.3rem;"></i>Add Members</div>
                <div style="margin-left: 1rem;margin-top: 0.5rem;">
                    {{ CurrencyCode }} {{ memberAddon ? memberAddon.addonPrice : 0 }} /per user
                    <button class="count-btn" @click="decrementMember" :disabled="memberCount <= 0">-</button> 
                    {{ memberCount }} 
                    <button class="minus-count-btn" @click="incrementMember" :disabled="memberCount >= maxMemberCount">+</button>
                </div>
                <div style="margin-left: 1rem; margin-top: 0.6rem;opacity:50%; font-size: 15px;">
                    This member will only be accessible if plan is active
                </div>
            </div>
        </div>
        <div class="add-ons">
            <label style="font-size: large;">Order Summary</label> 
            <div style="display: flex; justify-content: space-between;margin-top: 2rem;">
                <label>Startup Plan Addons - Tokens</label>
                <span style="opacity:50%; margin-right: 1rem;">{{ CurrencyCode }} {{ tokenTotalCost }}</span>
            </div>
            <div style="opacity:50%;">{{ CurrencyCode }} {{ tokenMonthlyCost }} single purchase</div>
            <div style="display: flex; justify-content: space-between;margin-top: 2rem;">
                <label>Startup Plan Addons - Members</label>
                <span style="opacity:50%; margin-right: 1rem;">{{ CurrencyCode }} {{ memberTotalCost }}</span>
            </div>
            <div style="opacity:50%;">{{ CurrencyCode }} {{ memberMonthlyCost }} single purchase</div>
            <hr style="height: 2px; background: black; color: black"/>
            <div style="display: flex; justify-content: space-between;margin-top: 1rem;">
                <label>Total</label> 
                <span style="opacity:50%; margin-right: 1rem;">{{ CurrencyCode }} {{ totalCost }}</span>
            </div>
            <div style="display: flex; justify-content: center;">
                <button class="pay-btn" :class="{'pay-btn-active': totalCost !== 0 }" :disabled="totalCost === 0" @click="purchaseAddons">
                    Pay {{ CurrencyCode }} {{ totalCost }} Now
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "AddOnsContent",
    data() {
        return {
            tokenCount: 0,
            memberCount: 0,
            billing: JSON.parse(localStorage.getItem('billingData')),
            addons: [],
            tokenAddon: null,
            memberAddon: null,
            maxTokenCount: 0,
            maxMemberCount: 0
        };
    },
    methods: {
        ...mapActions(['postPurchaseAddon']),
        incrementToken() {
            if (this.tokenCount < this.maxTokenCount) {
                this.tokenCount++;
            }
        },
        decrementToken() {
            if (this.tokenCount > 0) {
                this.tokenCount--;
            }
        },
        incrementMember() {
            if (this.memberCount < this.maxMemberCount) {
                this.memberCount++;
            }
        },
        decrementMember() {
            if (this.memberCount > 0) {
                this.memberCount--;
            }
        },
        async purchaseAddons() {
            let addonsToPurchase = [];
            if (this.tokenCount > 0 && this.tokenAddon) {
                addonsToPurchase.push({
                    Type: this.tokenAddon.addonType,
                    AddonCode: this.tokenAddon.addonCode,
                    Quantity: this.tokenCount
                });
            }
            if (this.memberCount > 0 && this.memberAddon) {
                addonsToPurchase.push({
                    Type: this.memberAddon.addonType,
                    AddonCode: this.memberAddon.addonCode,
                    Quantity: this.memberCount
                });
            }
            if (addonsToPurchase.length > 0) {
                const subscriptionId = this.billing.object.data.subscription.subScriptionId;
                const body = { Addons: addonsToPurchase };
                const data = { subscriptionId, body };
                const response = await this.postPurchaseAddon(data);
                const url = response.object.data.hostedpage.url;
                window.open(url, '_self');
            }
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user
        }),
        CurrencyCode() {
            return this.user.countryCode === 'IN' ? '₹' : '$';
        },
        tokenMonthlyCost() {
            return this.tokenCount * (this.tokenAddon ? this.tokenAddon.addonPrice : 0);
        },
        tokenTotalCost() {
            return this.tokenMonthlyCost;
        },
        memberMonthlyCost() {
            return this.memberCount * (this.memberAddon ? this.memberAddon.addonPrice : 0);
        },
        memberTotalCost() {
            return this.memberMonthlyCost;
        },
        totalCost() {
            return this.tokenTotalCost + this.memberTotalCost;
        }
    },
    created() {
        this.addons = this.billing.object.data.plan.addons;
        this.tokenAddon = this.addons.find(addon => addon.addonType === "Tokens");
        this.memberAddon = this.addons.find(addon => addon.addonType === "Member");
        if (this.tokenAddon) {
            this.maxTokenCount = this.tokenAddon.maxLimit - this.tokenAddon.consumed;
        }
        if (this.memberAddon) {
            this.maxMemberCount = this.memberAddon.maxLimit - this.memberAddon.consumed;
        }
    }
};
</script>

<style scoped>

.pay-btn-active{
    background: #704dff !important;
}

.pay-btn{
  background: #987efe;
  color: #ffffff;
  border: 1px solid #C4B5FD;
  width: 10rem;
  border-radius: 5px;
  margin-top: 1.5rem;
  height: 2.5rem
}
.add-ons {
    padding: 1rem 1rem;
    background-color: white;
    margin-left: 2rem;
    border-radius: 6px;
    margin-top: 3rem;
    width: 45%;
    box-shadow: 0 1px 3px rgba(101, 101, 101, 0.3);
    height: 21rem;
}

.single-counter {
    margin-top: 2rem;
    margin-left: 1rem;
}

.count-btn {
    margin-left: 15rem;
    border: none;
    border-radius: 5px;
    width: 2rem;
    margin-right: 0.5rem;
}

.minus-count-btn {
    border: none;
    border-radius: 5px;
    width: 2rem;
    margin-left: 0.5rem;
}
.all-card-container{
    display: flex;
}
@media (max-width: 480px) {
    .all-card-container{
        flex-direction: column;
    }
    .add-ons{
        width: 95%;
        height: 100%;
        margin-left: 0.5rem;
    }
    .count-btn{
        margin-left: 4rem;
    }
}
</style>